export const WDP_TPNRD_NO_COST =
  "The Water Data Program is brought to you by TPNRD at no cost";
export const CANT_FIND_PAGE =
  "Sorry, We can't find the page you're looking for";
export const INTERNET_CONNECTION_LOST = "Internet connection lost";
export const PLEASE_TRY_AGAIN_LATER = "Please try again later.";

//User Registration
export const SIGNUP_CODE_NOT_VALID = "Sign-up code is not valid";
export const SIGNUP_CODE_NEEDED = "Sign-up code is needed for registration";
export const USER_EMAIL_REGISTERED = "User email id is already registered";
export const MOBILE_NUMBER_REGISTERED =
  "Mobile phone number is already registered";
export const ENTER_REQUIRED_INFO = "Please enter required information";
export const UNIQUE_ENTITY_NAME = "Entity name should be unique";
export const EMAIL_NOT_MATCHING_WITH_CONFIRM_EMAIL =
  "Email does not match with confirm email";
export const MOBILE_NUMBER_NOT_MATCHING_WITH_CONFIRM_MOBILE_NUMBER =
  "Mobile phone number does not match with confirm mobile phone number";
export const ENTER_CONFIRM_EMAIL = "Please enter confirm email";
export const EMAIL_DONT_MATCH = "Emails does not match";
export const ENTER_CONFIRM_MOBILE_NUMBER =
  "Please enter confirm mobile phone number";
export const MOBILE_NUMBERS_DONT_MATCH = "Mobile phone numbers does not match";
export const ERROR_CALLING_FUNCTION = "Error while calling function";
export const COMPLETE_REGISTRATION =
  "Please complete registration for the TPNRD Water Data Program & your free AgHub account by completing the information below. Thank you!";
export const ENTER_LAST_NAME = "Please enter last name";
export const ENTER_ONLY_LETTERS = "Please enter only letters";
export const ENTER_MAIL = "Please enter email";
export const EMAIL_IS_INVALID = "Email is invalid";
export const INVALID_MOBILE_NUMBER = "Invalid mobile phone number";
export const ENTER_MAILING_ADDRESS = "Please enter mailing address";
export const INVALID_MAILING_ADDRESS = "Invalid mailing address";
export const ENTER_CITY = "Please enter city";
export const INVALID_CITY = "Invalid city";
export const ENTER_VALID_SIGN_UP_CODE = "Please enter a valid sign up code";
export const SELECT_ATLEAST_ONE_PROVIDER =
  "Please select at least one provider";
export const EXISTING_ACCOUNT_LOGIN = "Already have an account? - Log In";
export const ENTER_FIRST_NAME = "Please enter first name";
export const ENTER_ENTITY_NAME = "Please enter entity name";
export const INVALID_ENTITY_NAME = "Invalid entity name";
export const CONFIRM_INFO_BEFORE_PROCEEDING =
  "Please confirm your information before proceeding.";

//User Profile
export const ZIP_CODE_INVALID = "Zip code is invalid.";
export const ENTER_MOBILE_NUMBER = "Please enter mobile phone number";
export const SELECT_STATE = "Please select state";
export const ENTER_ZIP_CODE = "Please enter zip code";
export const INVALID_ZIP_CODE = "Invalid zip code";
export const ADD_LEGAL_ENTITIES_WITH_ACCOUNTS =
  "Please add all legal entities with electric irrigation accounts.";
export const INVALID_IMAGE_FILE =
  "Please select a valid image file (JPG, JPEG, PNG).";
export const FILE_SIZE_TOO_LARGE = "File size must be less than 5MB";
export const PROFILE_UPDATED_SUCCESSFULLY = "Profile updated successfully";
export const ERROR_WHILE_UPDATING_PROFILE =
  "Error while updating the user profile";
export const ERROR_WHILE_UPDATING_PROFILE_PICTURE =
  "Error while updating the profile picture";

//Login
export const ACCOUNT_DOES_NOT_EXIST = "The account does not exist";
export const INVALID_CREDENTIALS = "Invalid Credentials";
export const EMAIL_NOT_PRESENT_IN_DATABASE =
  "Email-id is not present in the database.";
export const PLEASE_ENTER_PASSWORD = "Please Enter Password";
export const NOT_REGISTERED_CLICK_HERE =
  "If you haven’t registered...Click here";
export const ENTER_USERNAME = "Please enter username";

//Registration Map
export const USER_CLAIMED_FIELDS = "User Claimed Fields";
export const USER_REGISTERED_FIELDS = "User Registered Fields";
export const INVALID_GPM = "Invalid GPM";
export const REGISTER_FIELD_OVERLAY_LOADING_TEXT =
  "Your request is under process, and registered fields will show in orange color in a while. If you don't find your registered field on the MAP, please contact the TPNRD admin.";
export const ADDED_FIELDS_WARNING =
  "To ensure all Fields Added are saved, you must either Submit the Fields Added or delete the added fields in Fields Added before performing this action.";

//Registration Panel
export const ERROR_WHILE_LOG_IN = "Error while logging in";
export const FIELD_ALREADY_REGISTERED =
  "The field you are trying to register is already registered by another farmer";
export const SELECTED_FIELD_NOT_IN_DATABASE =
  "The selected field is not present in the database";
export const SHARED_FIELD_WITH_OTHER_USER =
  "You have shared this field with other user(s).";
export const CONTACT_ADMIN_TO_DELETE_FIELD =
  "Please contact the admin to delete the field.";
export const ERROR_WHILE_DELETING_FIELD =
  "An error occurred while deleting the field.";
export const REMOVE_SELECTED_FIELD_CONFIRMATION =
  "Are you sure you want to remove selected field";
export const REMOVE_REGISTERED_FIELD_CONFIRMATION =
  "Are you sure you want to remove registered field";
export const REMOVE_REGISTERED_FIELD_NOTE =
  "NOTE: Removal of a field will lead to the deletion of all shared fields linked to it.";
export const REMOVE_CLAIMED_FIELD_CONFIRMATION =
  "Are you sure you want to remove claimed field";
export const ERROR_WHILE_MAKING_REQUEST = "Error while making request";
export const FIELD_IS_SHARED_BY = "This field is shared with you by";
export const SHARED_FIELD_NAME_IS = "The shared field name is";

//Add Field
export const ERROR_WHILE_CLAIMING_FIELD = "Error while claiming a field";
export const ERROR_WHILE_REGISTERING_FIELD = "Error while registering field";
export const FARM_NAME_CANNOT_BE_EMPTY = "Farm name cannot be empty";
export const BUSINESS_NAME_CANNOT_BE_EMPTY = "Business name cannot be empty";
export const FIELD_FARM_BUSINESS_CANNOT_BE_EMPTY =
  "Field, farm or business name cannot be empty";
export const ONE_WELL_SHOULD_BE_ACTIVE = "At least one well should be active";
export const NO_ACTIVE_POLYGON = "No active polygon";
export const ERROR_WHILE_UPDATING_FIELD = "Error while updating field details";
export const ENTER_VALUE = "Enter value";
export const INVALID_VALUE = "Invalid value";
export const ENTER_FARM_NAME = "Please enter farm name";
export const ENTER_BUSINESS_NAME = "Please enter business name";
export const ENTER_FIELD_NAME = "Please enter field name";
export const SELECT_BUSINESS = "Please select business";
export const SELECT_FARM = "Please select farm";
export const NO_FARMS_AVAILABLE_FOR_BUSINESS =
  "No farms available. Please add a farm.";
export const MANAGE_FARM_BUSINESS = "Manage Farm/Business";
export const NO_FIELDS_FOR_SELECTED_FILTER =
  "No fields available for the selected filter.";
export const SELECT_BUSINESS_AND_FARM_TO_VIEW_FIELDS =
  "Please select business and farm to view the fields.";
export const FARM_NAME_EXIST = "Farm name already exist";
export const BUSINESS_NAME_EXIST = "Business name already exist";
export const NAME_EXIST = "Name already exists";
export const ADD_UPTO_25_FIELDS =
  "You can add up to 25 fields at a time! Please submit the added fields first.";
export const UNABLE_TO_LOAD_FIELDS_CONTACT_CONTACT_ADMIN =
  "Unable to load Fields on the map. Please contact admin";

//Dashboard
export const ERROR_LOADING_GISC_DATA =
  "Error loading GiSC data. Please reload the page and try again";
export const SELECT_CUSTOM_DATE = "Please select custom date range or year.";
export const CROP_TILLAGE_SHOULD_NOT_BE_EMPTY =
  "Crop or Tillage should not be empty";
export const CROP_UNIQUE_FOR_SEASON = "Crop should be unique for a season";
export const YEAR_ACRES_ZERO_CANNOT_ADD_CROP =
  "Since current year acres are zero, you can not add crop.";
export const ERROR_WHILE_SAVING_DATA = "Error while saving data";
export const CROP_ALREADY_EXIST =
  "The crop(s) you are trying to add already exists";
export const RELOAD_PAGE_TRY_AGAIN = " please reload the page and try again";
export const CROP_ACRES_NOT_EXCEED_FIELD_ACRES =
  "Total crop acres should not exceed field acres";
export const ERROR_SAVING_CROP_DETAILS = "Error while saving crop details";
export const SESSION_HAS_EXPIRED =
  " Your session has expired. Please login again.";
export const LOADING_GRAPHS = "Loading Graphs...";
export const LOADING_DASHBOARD_DATA = "Loading Dashboard Data...";
export const DAILY_IRRIGATION_ACTIVITY = "Daily Irrigation Activity";
export const DAILY_WATER_USAGE = "Daily Water Usage (Inches)";
export const SELECT_FIELD_FOR_DAILY_WATER_USAGE =
  "Select a field to view daily water usage";
export const YEARLY_IRRIGATION_ACTIVITY = "Yearly Irrigation Activity";
export const MONTHLY_WATER_USAGE = "Monthly Water Usage (Inches)";
export const SELECT_FIELD_FOR_MONTHLY_WATER_USAGE =
  "Select a field to view monthly water usage";
export const RESETTING_FIELD_DATA = "Resetting field data...";
export const NO_FIELDS_REGISTER_IN_MAP =
  "There are no fields. Please select your fields in the Field Registration Map.";
export const NO_MATCHING_RECORDS = "There are no matching records.";
export const SAVING_FIELD_DATA = "Saving field data";
export const FIELD_DETAILS_SAVED_SUCCESSFULLY =
  "Field details saved successfully";
export const ERROR_FETCHING_METER_DATA =
  "Error while fetching user meter data.";
export const ERROR_FETCHING_ALL_IRRIGATION_FIELDS =
  "Error while fetching all irrigation fields.";

//Field Details
export const SHARED_FIELD_UPDATED_SUCCESSFULLY =
  "Shared field details updated successfully.";
export const DATA_UPDATED_SUCCESSFULLY = "Data updated Successfully";
export const FIELD_SHARED_BY = "Field shared by";
export const SHARED_FIELD_NAME = "Shared Field Name";

//WDP Panel
export const WONT_SEE_FIELD_AFTER_REJECTING_REQUEST =
  "After rejecting a share field request, you will not be able to see the field";
export const DELETE_SHARED_FIELD =
  "Are you sure you want to delete the shared field";
export const REJECT_SHARED_FIELD =
  "Are you sure you want to remove access to shared field";
export const DELETE_OR_REJECT_ACCESS_TO_SHARE_FIELD =
  "Delete or reject access to the shared field";
export const SHARED_FIELD_REJECTED_SUCCESSFULLY =
  "Shared field rejected successfully.";
export const ENTER_NAME = "Please enter the name";
export const TRANSFER_SAME_BUSINESS_VALIDATION = 
  "Selected farm(s) already belong to the target business. Please choose a different business.";

//Table Crop Details
export const SURE_TO_REMOVE = "Are you sure you want to remove";
export const PLEASE_ENTER_VALID_DATA = "Please enter valid data";
export const ADD_ATLEAST_ONE_CROP = "Add at least one crop";
export const CROP_ACRES_GREATER_THAN_ZERO =
  "Crop acres should be greater than zero";
export const ERROR_WHILE_GENERATING_PAYLOAD = "Error while generating payload";
export const DATA_SAVED_SUCCESSFULLY = "Data Saved Successfully";

//Multiple Crops&Tillages
export const SAVE_CROP_FOR_SELECTED_FIELD =
  "Do you want to Save this crop for selected field(s)?";
export const HAS_CROP_THIS_YEAR = "already has crop this year";
export const CROP_SAVED_SUCCESSFULLY = "Crop saved successfully";
export const FIELDS_NO_CROPS_SELECTED_YEAR =
  "Fields listed below have no crops added for the selected year.";
export const ADD_CROPS_TO_FIELDS =
  "Please take a moment and add crops to these fields.";

//Tab Summary
export const ERROR_FETCHING_WELL_SUMMARY_DETAILS =
  "Error while fetching well summary details";

//Tab SharedField Details
export const ERROR_FETCHING_SHARE_FIELD_DETAILS =
  "Error while fetching share field details";
export const PLEASE_SELECT_USER = "Please select user";
export const FIELD_SHARED_SUCCESSFULLY = "Field shared successfully.";
export const ALREADY_SHARED_FIELD_WITH =
  "You have already shared this field with";
export const ERROR_ADDING_SHARE_FIELD =
  "Error while adding share field details.";
export const ERROR_STOPPING_SHARED_ACCESS_TO_FIELD =
  "Error while stopping the shared access of the field.";
export const REMOVED_ON_STATUS_UPDATED_SUCCESSFULLY =
  "Removed on status updated successfully.";
export const SECONDARY_USER_REJECTED_SHARE_FIELD =
  "The secondary user already rejected the shared field.";
export const SHARED_FIELD_DELETED_SUCCESSFULLY =
  "Shared field deleted successfully.";
export const ERROR_CHANGING_SHARED_FIELD_ACCESS =
  "Error while changing shared field access.";
export const SHARED_FIELD_ACCESS_CHANGES_SUCCESSFULLY =
  "Shared field access changed successfully.";
export const USER_WONT_SEE_CROP_FROM_NEXT_SEASON =
  "The user will not be able to see the crop details from the next season.";
export const DO_YOU_WANT_TO_CHANGE_ACCESS = "Do you want to change the access?";
export const SHARE_FIELD_WITH = "Do you want to share this field with";
export const CANNOT_SHARE_FIELD_WITH_YOURSELF =
  "cannot share this field with yourself";
export const SELECT_USER_TO_SHARE_FIELD_WITH =
  "Please select the user to share this field.";
export const EMAIL_SENT_SUCCESSFULLY = "Email sent successfully.";
export const ERROR_SEARCHING_USER = "Error while searching user";
export const ERROR_SHARING_FIELDS = "Error while sharing field(s)";
export const SELECT_ATLEAST_ONE_FIELD_TO_SHARE =
  "Please select at least a single field to share";
export const SHARE_UPTO_50_FIELDS =
  "You can share only up to 50 fields at a time";
export const NO_PERMISSION_ADDING_CROPS =
  "Your permission level does not include adding crops or tillage practice.";
export const ERROR_DELETING_SHARED_FIELD = "Error while deleting shared field";
export const DELETE_RECORD_CONFIRMATION = "Do you want delete the record?";
export const DELETE_RECORD = "This will delete the shared record.";

// Tab Report
export const REPORT_SENT_SUCCESSFULLY = "Report sent successfully.";
export const REPORT_ERROR_OCCURRED = `Error while submitting report. ${PLEASE_TRY_AGAIN_LATER}`;
export const EMPTY_REPORT = "Please submit a valid report";

// Tab Staff Notes
export const NOTES_SAVED_SUCCESSFULLY = "Notes were saved successfully.";
export const ERROR_FETCHING_STAFF_NOTES = "Error while fetching staff notes";
export const ERROR_SAVING_STAFF_NOTES = "Error while saving staff notes";
export const EMPTY_NOTE = "Please enter valid staff notes";

// Staff Notes for Farmer
export const FARMER_NOTES_SAVED_SUCCESSFULLY =
  "Farmer notes were saved successfully";
export const ERROR_FETCHING_FARMER_NOTES = "Error while fetching farmer notes";
export const ERROR_SAVING_FARMER_NOTES = "Error while saving farmer notes";
export const EMPTY_FARMER_NOTE = "Please enter valid farmer notes";

//FieldShare
export const SHARE_FIELDS_WITH = "Do you want to share the field(s) with";
export const SELECT_USER_TO_SHARE_FIELDS_WITH =
  "Please select the user to share field(s)";
export const SELECT_SHARING_TYPE = "Please select the sharing type";
export const FIELDS_SHARED_SUCCESSFULLY = "Field(s) shared successfully.";

//Forgot Password
export const INVALID_VERIFICATION_CODE = "Invalid verification code";
export const ENTER_VERIFICATION_CODE = "Please enter verification code";
export const VERIFICATION_CODE_SPACES =
  "Verification code cannot contain spaces";
export const ENTER_PASSWORD = "Please enter password";
export const PASSWORD_CONTAINS_SPACES = "Password cannot contain spaces";
export const PASSWORD_EIGHT_CHARACTERS =
  "Password must be at least 8 characters long";
export const PASSWORD_DO_NOT_MATCH = "Password does not match";
export const RE_ENTER_PASSWORD = "Please re-enter password";
export const ENTER_NEW_PASSWORD = "Please enter new password";
export const PASSWORD_UPDATED_SUCCESSFULLY =
  "Password updated successfully. Please login with the new password.";
export const ENTER_VALID_EMAIL = "Please enter a valid email";
export const SET_NEW_PASSWORD = "Set a New Password";
export const RESTORE_PASSWORD = "Restore Password";
export const ENTER_EMAIL_TO_RECEIVE_VERIFICATION_CODE =
  "Enter your email address to receive the verification code on your registered mobile phone number to change the password.";

//Password Verification
export const ERROR_TRY_AFTER_SOMETIME = "Error! Please try after some time";
export const CONFIRM_ACCOUNT_BEFORE_LOGIN =
  "Your account has not confirmed yet, please confirm your account before login";
export const RESEND_VERIFICATION_CODE = "Resend verification code";
export const ENTER_VERIFICATION_CODE_RECEIVED =
  "Please enter verification code received on your mobile phone number.";
export const ERROR_CREATING_USER = "Error while creating user";
export const FAILED_SIGN_UP_CONTACT_ADMIN =
  "Failed to sign up, please contact admin.";
export const SUCCESSFULLY_RESEND_CODE_FOR_USER =
  "Successfully resent code for user";
export const ERROR_RESENDING_CODE_FOR_USER =
  "Error while resending code for user";
export const SUCCESSFULLY_AUTO_SIGNED_IN_FOR_USER =
  "Successfully auto signed in for user";
export const ERROR_AUTO_SIGNING_FOR_USER =
  "Error while auto signing in for user";
export const ERROR_CONFIRMING_USER = "Error while confirming user";
export const ERROR_HAS_OCCURED = "Error has occured";
export const CONFIRM_ACCOUNT = "Please confirm your account";
export const FINISH_SETTING_UP_ACCOUNT_CREATE_PASSWORD =
  "To finish setting up your account, please create your own password.";
export const GENERATE_PASSWORD = "Generate Your Password";

//Change Password
export const ENTER_OLD_PASSWORD = "Please enter old password";
export const NEW_PASSWORD_SHOULD_BE_DIFFERENT =
  "The new password should be different from the old password";
export const PASSWORD_UPDATED = "Password updated successfully";
export const ENTER_CORRECT_OLD_PASSWORD =
  "Please enter the correct old password";
export const ATTEMPT_LIMIT_EXCEEDED =
  "Attempt limit exceeded, please try after some time";
export const ERROR_WHILE_ATTEMPTING_CHANGE_PASSWORD =
  "An error occurred while attempting to change the password";

//Staff Login
export const FARMER_LOGIN_ERROR = "Farmer Login Error";
export const LOGIN_SESSION_DID_NOT_OPEN =
  "The login session for this farmer did not open corrently.";
export const CLOSE_WINDOW_TRY_AGAIN =
  "Please close the window and try logging in again.";
export const MAIL_SENT_WITH_FARMER_CREDENTIALS =
  "Mail with farmer credentials sent successfully";
export const ERROR_SENDING_MAIL = `Error while sending mail. ${PLEASE_TRY_AGAIN_LATER}`;
export const PLEASE_SELECT_FARMER_TO_LOGIN = "Please select a farmer to login";

//Well Test Form
export const ENTER_VALID_GPM = "Please enter a valid GPM";
export const ENTER_VALID_PUMP_RATE = "Please enter a valid Pump Rate";
export const ENTER_PUMP_RATE = "Please enter a Pump Rate";
export const FORM_SUBMITTED_SUCCESSFULLY = "Form submitted successfully";
export const NO_FORMS_SAVED_LOCALLY = "No forms saved locally";
export const YOU_ARE_OFFLINE = "You are offline";
export const FORM_SAVED_LOCALLY = "Form saved locally";
export const SOME_FORMS_NOT_SUBMITTED = "Some forms couldn't be submitted";
export const SELECT_IRRIGATION_COMPANY = "Please select an Irrigation Company";
export const SELECT_DATE = "Please select a date";
export const SELECT_WELL_REGISTRATION_ID =
  "Please select a Well Registration ID";
export const ENTER_VALID_ACRES = "Please enter valid acres";
export const ENTER_VALID_PIPE_WALL_THICKNESS =
  "Please enter a valid Pipe Wall Thickness";
export const ENTER_WELL_OWNER_NAME = "Please enter a Well Owner Name";
export const ENTER_VALID_PHONE_NUMBER = "Please enter a valid phone number";

// Well Connection Report
export const WELL_DETAILS_UPDATED_SUCCESSFULLY =
  "Well details updated successfully";
export const UPDATE_WELL_CONNECTION_INFO =
  "Update the Meter and Account ID in case of any discrepancy in the data shown";
export const UPDATE_WELL_CONNECTION_CONFIRMATION =
  "Are you sure you want to update the well connection details for well";
export const WELL_CONNECTION_DETAILS_UPDATED =
  "Well connection details have been updated for well";

// Consent Popup
export const CONSENT_ERROR =
  "Error occured while submitting consent. Try again later";

//Field Transfer
export const FIELD_TRANSFER_VALIDATION =
  "Please make sure to select a farmer and farm to transfer the fields to";
export const SAME_FARMER_VALIDATION =
  "Same farmer cannot be selected for transferring fields";
export const EMPTY_FIELD_NAME_VALIDATION =
  "Field name cannot be empty while transferring to another farmer";
export const UNIQUE_FIELD_NAME_VALIDATION = "Field names should be unique";
export const FIELD_TRANSFER_SUCCESSFUL = "Field Transfer Successful";

// Well Chemigation Report
export const ERROR_LOADING_FARMER_LIST = "Error while loading the farmer list";
export const ERROR_LOADING_WELL_IRRIG_UNIT_LIST =
  "Error while loading the well and irrig unit list";
export const INCOMING_TOKEN_HAS_EXPIRED = "The incoming token has expired";

//Staff Report
export const STAFF_AUTHORIZED =
  "This section is strictly for use by Twin Platte NRD authorized personnel.";
export const FIELD_TRANSFER_BANNER =
  "This section allows fields to be transferred from one farmer to another.";
export const STAFF_FARMER_LOGIN_BANNER =
  "This section allows staff to login in as any of the farmers and view, edit or make notes for the farmer.";
export const BACK_TO_LOGIN = "Go back to login";

//Error Messages
export const ERROR_FETCHING_FARM_BUSINESS =
  "Error while fetching farms and businesses";
export const ERROR_FETCHING_FIELDS_WITH_NO_CROPS =
  "Error while fetching fields with no crops";
export const ERROR_WHILE_SENDING_CONSENT = "Error while sending consent";
export const ERROR_LOADING_USER_PROFILE = "Error while loading user profile";
export const ERROR_FETCHING_GRAPH_DATA = "Error while fetching graph data";
export const ERROR_SAVING_FIELD_DETAILS = "Error while saving field details";
export const ERROR_FETCHING_FIELD_DETAILS =
  "Error while fetching field details";
export const ERROR_FETCHING_REGISTERED_FIELDS =
  "Error while fetching registered field(s)";
export const ERROR_SENDING_MESSAGE_TO_QUEUE =
  "Error while sending message to queue";
export const ERROR_VALIDATING_REGISTRATION_REQUEST =
  "Error while validating registration request";
export const ERROR_FETCHING_FARMER_LIST = "Error while fetching farmer list";
export const ERROR_LOADING_AREA_AVERAGES = "Error while loading area averages";
export const ERROR_DOWNLOADING_WELL_REPORT =
  "Error while downloading the well report";

export const ERROR_UPDATING_WELL_CONNECTION_DETAILS =
  "Error while updating well connection details";

export const ERROR_SUBMITTING_WELL_TEST_FORM =
  "Error while submitting well test form(s)";
export const ERROR_FETCHING_PRECIP_DATA =
  "Error while fetching precipitation data";
export const ERROR_FETCHING_PUMP_RATES_REPORT =
  "Error while fetching pump rates report";

// Pump Rates Report
export const PUMP_RATES_REPORT_DESCRIPTION =
  "This section provides pump rates and audit dates for all wells associated with your fields";
